var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.confirmingMode)?_c('div',[_vm._t("confirm"),_vm._t("cancel",null,null,{hideConfirm: _vm.hideConfirm})],2):_vm._t("default",null,null,{showConfirm: _vm.showConfirm})],2)}
var staticRenderFns = []

export { render, staticRenderFns }